import {Directive, ElementRef, Input, OnDestroy, Renderer2} from '@angular/core';
import {take} from 'rxjs/operators';
import {Subscription} from 'rxjs';
import {fromEvent} from 'rxjs';
import {environment} from '@environments/environment';

/**
 * Заглушка для несуществующих изображений
 */

@Directive({selector: '[appFallbackImage]'})
export class FallbackImageDirective implements OnDestroy {

    @Input() appFallbackImage: string;

    private sub: Subscription;

    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
    ) {
        this.sub = fromEvent(this.el.nativeElement, 'error').pipe(
            take(1)
        ).subscribe(() => {
            const src = this.appFallbackImage || environment.fallbackImageUrl;
            this.renderer.setAttribute(this.el.nativeElement, 'src', src);
        });
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}
